export default function Sass_Installation() {
  return (
    <div>
      <h1>Sass Installation</h1>
    </div>
  );
}
